<script lang="ts">
  import PantallaCarga from '@/lib/ui/PantallaCarga.svelte';
  import LineaTiempo from '@/lib/ui/LineaTiempo.svelte';
  import { siguientePaso } from '@/lib/estado/pasos';
  import { prefersReducedMotion } from 'svelte/motion';
  import { onMount } from 'svelte';

  import { iniciarAudio } from '@/lib/estado/audio';

  let cargado = $state(false);

  function iniciar() {
    siguientePaso(); // INICIO → SOL (Paso 2)
    void iniciarAudio(); // Reproducción inmediata con el gesto de usuario
    cargado = true;
  }

  /** Parallax sutil en mobile: mueve el cielo según la inclinación del dispositivo. */
  onMount(() => {
    if (prefersReducedMotion.current) return;

    const manejarOrientacion = (event: DeviceOrientationEvent) => {
      const beta = event.beta ?? 0; // -180 a 180 (front-back)
      const gamma = event.gamma ?? 0; // -90 a 90 (left-right)
      if (beta === null || gamma === null) return;

      const offsetX = Math.max(-3, Math.min(3, gamma / 30));
      const offsetY = Math.max(-3, Math.min(3, (beta - 45) / 30));

      const cielo = document.querySelector('.cielo') as HTMLElement | null;
      if (cielo) {
        cielo.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
      }
    };

    window.addEventListener('deviceorientation', manejarOrientacion);
    return () => window.removeEventListener('deviceorientation', manejarOrientacion);
  });
</script>

{#if !cargado}
  <PantallaCarga alIniciar={iniciar} />
{:else}
  <LineaTiempo />
{/if}

<style>
  :global(body) {
    background: var(--color-cielo-noche);
  }
</style>
